<template>
  <base-modal ref="modal" @hiding="reset">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div
          class="tw-flex tw-flex-shrink-0 tw-mx-auto tw-justify-center tw-items-center tw-bg-primary-50 tw-w-12 tw-h-12 tw-rounded-full sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10 sm:tw-my-auto"
        >
          <plus-minus-icon class="tw-w-5 tw-h-5 tw-text-primary-500" />
        </div>
        <div class="sm:tw-flex-col sm:tw-items-start sm:tw-ml-2 sm:tw-justify-start tw-mt-3 sm:tw-mt-0 tw-text-center sm:tw-text-left">
          <div class="tw-font-thin tw-text-xl">Adjust credits</div>
          <div class="tw-text-gray-600 tw-font-light">How many credits?</div>
        </div>
      </div>
      <div class="tw-flex tw-justify-center tw-mt-6 tw-gap-6">
        <base-icon class="tw-my-auto tw-bg-primary-50" color="primary" @click="subtract"> <minus-icon class="tw-h-6 tw-w-6"/></base-icon>
        <base-text-field type="number" class="tw-text-center tw-w-24" v-model="changeCount" />
        <base-icon class="tw-my-auto tw-bg-primary-50" color="primary" @click="add"> <plus-icon class="tw-h-6 tw-w-6"/></base-icon>
      </div>
      <inline-error class="tw-mt-3" id="adjust-credits-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-6">
        <base-button class="tw-w-full sm:tw-w-auto sm:tw-ml-3" v-if="changeCount == 0" disabled type="primary">Adjust Credits</base-button>
        <base-button class="tw-w-full sm:tw-w-auto sm:tw-ml-3" v-else-if="changeCount > 0" type="primary" @click="adjustCredits" :loading="isLoading">Adjust Credits</base-button>
        <base-button class="tw-w-full sm:tw-w-auto sm:tw-ml-3" v-else type="primary" @click="adjustCredits" :loading="isLoading">Delete Credits</base-button>
        <base-button class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" type="flat" @click="hide">Cancel</base-button>
      </div>
    </base-card>
  </base-modal>
</template>
<script>
import { MinusIcon, PlusIcon, PlusMinusIcon } from "@/assets/svgs";
import InlineError from "@/components/InlineError";

export default {
  name: "CreditAdjust",
  props: {
    businessId: String,
    userId: String,
    plan: Object,
  },
  components: { MinusIcon, PlusIcon, InlineError, PlusMinusIcon },
  data() {
    return {
      changeCount: 0,
      isLoading: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    reset() {
      this.changeCount = 0;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    add() {
      this.changeCount++;
    },
    subtract() {
      if (this.plan.creditsBalance - Math.abs(this.changeCount) == 0) return;
      else this.changeCount--;
    },
    adjustCredits() {
      this.isLoading = true;

      if (this.changeCount > 0) {
        this.$axios
          .post(`/businesses/${this.businessId}/members/${this.userId}/plans/${this.plan.userBusinessPlanId}/credits/add`, {
            count: this.changeCount,
          })
          .then(() => {
            this.$emit("save");
            this.isLoading = false;
            this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Credits Added", message: "You added " + this.changeCount + " credits" });
            this.EventBus.$emit("member_update");
            this.hide();
          })
          .catch((err) => {
            this.errorTitle = `Failed to add credits`;
            this.errorMessage = `We were not able to add these credits. Please try again.`;
            this.error = err;
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else if (this.changeCount < 0) {
        this.$axios
          .post(`/businesses/${this.businessId}/members/${this.userId}/plans/${this.plan.userBusinessPlanId}/credits/delete`, {
            count: this.changeCount * -1,
          })
          .then(() => {
            this.$emit("save");
            this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Credits Deleted", message: "You deleted " + Math.abs(this.changeCount) + " credits" });
            this.EventBus.$emit("member_update");
            this.hide();
          })
          .catch((err) => {
            this.errorTitle = `Failed to delete credits`;
            this.errorMessage = `We were not able to delete these credits. Please try again.`;
            this.error = err;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>
